import { Directive, Input, OnDestroy } from "@angular/core";
import { ControlValueAccessor } from "@angular/forms";
import { Subject } from "rxjs";

@Directive()
export abstract class BaseControlValueAccessor<T> implements ControlValueAccessor, OnDestroy {
    private _formValue: T | null = null;

    protected destroyed$ = new Subject<void>();

    protected onValChange: (value: T | null) => void = () => {};
    protected onTouched: () => void = () => {};

    private _disabled = false;

    get isDisabled() {
        return this._disabled;
    }

    get formValue() {
        return this._formValue;
    }

    @Input() set formValue(value: T | null) {
        this._formValue = value;
    }

    writeValue(value: T | null): void {
        this._formValue = value;
        this.onWriteValue(value);
    }

    registerOnChange(fn: (value: T | null) => void): void {
        this.onValChange = fn;
    }

    registerOnTouched(fn: () => {}): void {
        this.onTouched = fn;
    }

    setDisabledState(isDisabled: boolean) {
        this._disabled = isDisabled;
    }

    protected abstract onWriteValue(value: T | null): void;

    ngOnDestroy() {
        this.destroyed$.next();
        this.destroyed$.complete();
    }
}
